import SuccesPage from './successPage';

export default SuccesPage;
